import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function Blog() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
      {" "}
      <div class=" text-gray-600">
        <div
          class="w-full bg-center bg-cover h-[15rem] lg:h-[25rem] "
          style={{
            "background-image": "url('./hbg.png')",
          }}
        >
          <div class="flex items-center justify-center w-full h-full  ">
            <div class="text-center">
              <h1 class="text-2xl font-bold text-white py-3 lg:text-7xl">
                Our Blogs
              </h1>
              <h1 class="text-sm lg:text-base font- text-white w-full md:w-[28rem] ">
                we're more than just a digital media agency - we're your
                partners in business growth
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className="container px-2 lg:px-12   mx-auto ">
        <div className=" grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3 my-20">
          <div>
            <img
              className="object-cover object-center w-full h-64 rounded-lg lg:h-80"
              src="../Rectangle.png"
              alt=""
            />

            <div className="mt-8">
              <h1 className="mt-4 text-xl font-semibold text-gray-800">
                The Art of Storytelling: How to Use Narrative to Connect with
                Your Audience and Drive Engagement
              </h1>
              <div className="flex items-center justify-between mt-4">
                <div className="flex items-center gap-x-2">
                  <img
                    className="object-cover object-center w-5 h-5 md:w-9 md:h-9 rounded-full "
                    src="../Rectangle.png"
                    alt=""
                  />
                  <h1 className="text-xs sm:text-sm font-semibold text-gray-800">
                    Willion kalu
                  </h1>{" "}
                  -
                  <p className="text-[10px] sm:text-xs text-gray-500 ">
                    February 1, 2022
                  </p>
                </div>
                <p className="text-[8px] sm:text-xs text-gray-500 flex items-center gap-x-1">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_2390_316"
                      style={{ "mask-type": "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="21"
                      height="21"
                    >
                      <rect
                        x="0.00488281"
                        y="0.84082"
                        width="20"
                        height="20"
                        fill="#D9D9D9"
                      />
                    </mask>
                    <g mask="url(#mask0_2390_316)">
                      <path
                        d="M10.0052 19.174C8.85243 19.174 7.7691 18.9552 6.75521 18.5177C5.74132 18.0802 4.85938 17.4865 4.10938 16.7365C3.35937 15.9865 2.76562 15.1045 2.32812 14.0907C1.89062 13.0768 1.67188 11.9934 1.67188 10.8407C1.67188 9.68788 1.89062 8.60455 2.32812 7.59066C2.76562 6.57677 3.35937 5.69482 4.10938 4.94482C4.85938 4.19482 5.74132 3.60107 6.75521 3.16357C7.7691 2.72607 8.85243 2.50732 10.0052 2.50732C11.158 2.50732 12.2413 2.72607 13.2552 3.16357C14.2691 3.60107 15.151 4.19482 15.901 4.94482C16.651 5.69482 17.2448 6.57677 17.6823 7.59066C18.1198 8.60455 18.3385 9.68788 18.3385 10.8407C18.3385 11.2157 18.3177 11.5837 18.276 11.9448C18.2344 12.3059 18.1649 12.6601 18.0677 13.0073C17.8733 12.7851 17.6476 12.5976 17.3906 12.4448C17.1337 12.292 16.8524 12.1879 16.5469 12.1323C16.5885 11.924 16.6198 11.7122 16.6406 11.4969C16.6615 11.2816 16.6719 11.0629 16.6719 10.8407C16.6719 8.97955 16.026 7.40316 14.7344 6.11149C13.4427 4.81982 11.8663 4.17399 10.0052 4.17399C8.1441 4.17399 6.56771 4.81982 5.27604 6.11149C3.98438 7.40316 3.33854 8.97955 3.33854 10.8407C3.33854 12.7018 3.98438 14.2782 5.27604 15.5698C6.56771 16.8615 8.1441 17.5073 10.0052 17.5073C10.7135 17.5073 11.3906 17.4032 12.0365 17.1948C12.6823 16.9865 13.276 16.6948 13.8177 16.3198C13.9844 16.5559 14.1892 16.7643 14.4323 16.9448C14.6753 17.1254 14.9358 17.2643 15.2135 17.3615C14.5052 17.9309 13.7101 18.3754 12.8281 18.6948C11.9462 19.0143 11.0052 19.174 10.0052 19.174ZM16.0469 15.8407C15.7552 15.8407 15.5087 15.74 15.3073 15.5386C15.1059 15.3372 15.0052 15.0907 15.0052 14.799C15.0052 14.5073 15.1059 14.2608 15.3073 14.0594C15.5087 13.858 15.7552 13.7573 16.0469 13.7573C16.3385 13.7573 16.5851 13.858 16.7865 14.0594C16.9878 14.2608 17.0885 14.5073 17.0885 14.799C17.0885 15.0907 16.9878 15.3372 16.7865 15.5386C16.5851 15.74 16.3385 15.8407 16.0469 15.8407ZM12.7552 14.7573L9.17188 11.174V6.67399H10.8385V10.5073L13.9219 13.5907L12.7552 14.7573Z"
                        fill="#576B74"
                      />
                    </g>
                  </svg>
                  10 mins read
                </p>
              </div>

              <p className="mt-2 text-gray-500 ">
                Aenean eleifend ante maecenas pulvinar montes lorem et pede dis
                dolor pretium donec dictum. Vici consequat justo enim. Venenatis
                eget adipiscing luctus lorem.
              </p>
              <div className=" flex gap-x-4 mt-5 items-center">
                <Link
                  to="/blog"
                  className="w-[7rem] bg-[#DA281C] rounded-lg text-sm  py-3 text-center text-white  transition duration-200 hover:bg-[#757E7E]"
                >
                  Read more
                </Link>
              </div>
            </div>
          </div>
          <div>
            <img
              className="object-cover object-center w-full h-64 rounded-lg lg:h-80"
              src="../Rectangle.png"
              alt=""
            />

            <div className="mt-8">
              <h1 className="mt-4 text-xl font-semibold text-gray-800">
                The Art of Storytelling: How to Use Narrative to Connect with
                Your Audience and Drive Engagement
              </h1>
              <div className="flex items-center justify-between mt-4">
                <div className="flex items-center gap-x-2">
                  <img
                    className="object-cover object-center w-5 h-5 md:w-9 md:h-9 rounded-full "
                    src="../Rectangle.png"
                    alt=""
                  />
                  <h1 className="text-xs sm:text-sm font-semibold text-gray-800">
                    Willion kalu
                  </h1>{" "}
                  -
                  <p className="text-[10px] sm:text-xs text-gray-500 ">
                    February 1, 2022
                  </p>
                </div>
                <p className="text-[8px] sm:text-xs text-gray-500 flex items-center gap-x-1">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_2390_316"
                      style={{ "mask-type": "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="21"
                      height="21"
                    >
                      <rect
                        x="0.00488281"
                        y="0.84082"
                        width="20"
                        height="20"
                        fill="#D9D9D9"
                      />
                    </mask>
                    <g mask="url(#mask0_2390_316)">
                      <path
                        d="M10.0052 19.174C8.85243 19.174 7.7691 18.9552 6.75521 18.5177C5.74132 18.0802 4.85938 17.4865 4.10938 16.7365C3.35937 15.9865 2.76562 15.1045 2.32812 14.0907C1.89062 13.0768 1.67188 11.9934 1.67188 10.8407C1.67188 9.68788 1.89062 8.60455 2.32812 7.59066C2.76562 6.57677 3.35937 5.69482 4.10938 4.94482C4.85938 4.19482 5.74132 3.60107 6.75521 3.16357C7.7691 2.72607 8.85243 2.50732 10.0052 2.50732C11.158 2.50732 12.2413 2.72607 13.2552 3.16357C14.2691 3.60107 15.151 4.19482 15.901 4.94482C16.651 5.69482 17.2448 6.57677 17.6823 7.59066C18.1198 8.60455 18.3385 9.68788 18.3385 10.8407C18.3385 11.2157 18.3177 11.5837 18.276 11.9448C18.2344 12.3059 18.1649 12.6601 18.0677 13.0073C17.8733 12.7851 17.6476 12.5976 17.3906 12.4448C17.1337 12.292 16.8524 12.1879 16.5469 12.1323C16.5885 11.924 16.6198 11.7122 16.6406 11.4969C16.6615 11.2816 16.6719 11.0629 16.6719 10.8407C16.6719 8.97955 16.026 7.40316 14.7344 6.11149C13.4427 4.81982 11.8663 4.17399 10.0052 4.17399C8.1441 4.17399 6.56771 4.81982 5.27604 6.11149C3.98438 7.40316 3.33854 8.97955 3.33854 10.8407C3.33854 12.7018 3.98438 14.2782 5.27604 15.5698C6.56771 16.8615 8.1441 17.5073 10.0052 17.5073C10.7135 17.5073 11.3906 17.4032 12.0365 17.1948C12.6823 16.9865 13.276 16.6948 13.8177 16.3198C13.9844 16.5559 14.1892 16.7643 14.4323 16.9448C14.6753 17.1254 14.9358 17.2643 15.2135 17.3615C14.5052 17.9309 13.7101 18.3754 12.8281 18.6948C11.9462 19.0143 11.0052 19.174 10.0052 19.174ZM16.0469 15.8407C15.7552 15.8407 15.5087 15.74 15.3073 15.5386C15.1059 15.3372 15.0052 15.0907 15.0052 14.799C15.0052 14.5073 15.1059 14.2608 15.3073 14.0594C15.5087 13.858 15.7552 13.7573 16.0469 13.7573C16.3385 13.7573 16.5851 13.858 16.7865 14.0594C16.9878 14.2608 17.0885 14.5073 17.0885 14.799C17.0885 15.0907 16.9878 15.3372 16.7865 15.5386C16.5851 15.74 16.3385 15.8407 16.0469 15.8407ZM12.7552 14.7573L9.17188 11.174V6.67399H10.8385V10.5073L13.9219 13.5907L12.7552 14.7573Z"
                        fill="#576B74"
                      />
                    </g>
                  </svg>
                  10 mins read
                </p>
              </div>
              <p className="mt-2 text-gray-500 ">
                Aenean eleifend ante maecenas pulvinar montes lorem et pede dis
                dolor pretium donec dictum. Vici consequat justo enim. Venenatis
                eget adipiscing luctus lorem.
              </p>
              <div className=" flex gap-x-4 mt-5 items-center">
                <Link
                  to="/blog"
                  className="w-[7rem] bg-[#DA281C] rounded-lg text-sm  py-3 text-center text-white  transition duration-200 hover:bg-[#757E7E]"
                >
                  Read more
                </Link>
              </div>
            </div>
          </div>
          <div>
            <img
              className="object-cover object-center w-full h-64 rounded-lg lg:h-80"
              src="../Rectangle.png"
              alt=""
            />

            <div className="mt-8">
              <h1 className="mt-4 text-xl font-semibold text-gray-800">
                The Art of Storytelling: How to Use Narrative to Connect with
                Your Audience and Drive Engagement
              </h1>
              <div className="flex items-center justify-between mt-4">
                <div className="flex items-center gap-x-2">
                  <img
                    className="object-cover object-center w-5 h-5 md:w-9 md:h-9 rounded-full "
                    src="../Rectangle.png"
                    alt=""
                  />
                  <h1 className="text-xs sm:text-sm font-semibold text-gray-800">
                    Willion kalu
                  </h1>{" "}
                  -
                  <p className="text-[10px] sm:text-xs text-gray-500 ">
                    February 1, 2022
                  </p>
                </div>
                <p className="text-[8px] sm:text-xs text-gray-500 flex items-center gap-x-1">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_2390_316"
                      style={{ "mask-type": "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="21"
                      height="21"
                    >
                      <rect
                        x="0.00488281"
                        y="0.84082"
                        width="20"
                        height="20"
                        fill="#D9D9D9"
                      />
                    </mask>
                    <g mask="url(#mask0_2390_316)">
                      <path
                        d="M10.0052 19.174C8.85243 19.174 7.7691 18.9552 6.75521 18.5177C5.74132 18.0802 4.85938 17.4865 4.10938 16.7365C3.35937 15.9865 2.76562 15.1045 2.32812 14.0907C1.89062 13.0768 1.67188 11.9934 1.67188 10.8407C1.67188 9.68788 1.89062 8.60455 2.32812 7.59066C2.76562 6.57677 3.35937 5.69482 4.10938 4.94482C4.85938 4.19482 5.74132 3.60107 6.75521 3.16357C7.7691 2.72607 8.85243 2.50732 10.0052 2.50732C11.158 2.50732 12.2413 2.72607 13.2552 3.16357C14.2691 3.60107 15.151 4.19482 15.901 4.94482C16.651 5.69482 17.2448 6.57677 17.6823 7.59066C18.1198 8.60455 18.3385 9.68788 18.3385 10.8407C18.3385 11.2157 18.3177 11.5837 18.276 11.9448C18.2344 12.3059 18.1649 12.6601 18.0677 13.0073C17.8733 12.7851 17.6476 12.5976 17.3906 12.4448C17.1337 12.292 16.8524 12.1879 16.5469 12.1323C16.5885 11.924 16.6198 11.7122 16.6406 11.4969C16.6615 11.2816 16.6719 11.0629 16.6719 10.8407C16.6719 8.97955 16.026 7.40316 14.7344 6.11149C13.4427 4.81982 11.8663 4.17399 10.0052 4.17399C8.1441 4.17399 6.56771 4.81982 5.27604 6.11149C3.98438 7.40316 3.33854 8.97955 3.33854 10.8407C3.33854 12.7018 3.98438 14.2782 5.27604 15.5698C6.56771 16.8615 8.1441 17.5073 10.0052 17.5073C10.7135 17.5073 11.3906 17.4032 12.0365 17.1948C12.6823 16.9865 13.276 16.6948 13.8177 16.3198C13.9844 16.5559 14.1892 16.7643 14.4323 16.9448C14.6753 17.1254 14.9358 17.2643 15.2135 17.3615C14.5052 17.9309 13.7101 18.3754 12.8281 18.6948C11.9462 19.0143 11.0052 19.174 10.0052 19.174ZM16.0469 15.8407C15.7552 15.8407 15.5087 15.74 15.3073 15.5386C15.1059 15.3372 15.0052 15.0907 15.0052 14.799C15.0052 14.5073 15.1059 14.2608 15.3073 14.0594C15.5087 13.858 15.7552 13.7573 16.0469 13.7573C16.3385 13.7573 16.5851 13.858 16.7865 14.0594C16.9878 14.2608 17.0885 14.5073 17.0885 14.799C17.0885 15.0907 16.9878 15.3372 16.7865 15.5386C16.5851 15.74 16.3385 15.8407 16.0469 15.8407ZM12.7552 14.7573L9.17188 11.174V6.67399H10.8385V10.5073L13.9219 13.5907L12.7552 14.7573Z"
                        fill="#576B74"
                      />
                    </g>
                  </svg>
                  10 mins read
                </p>
              </div>
              <p className="mt-2 text-gray-500 ">
                Aenean eleifend ante maecenas pulvinar montes lorem et pede dis
                dolor pretium donec dictum. Vici consequat justo enim. Venenatis
                eget adipiscing luctus lorem.
              </p>
              <div className=" flex gap-x-4 mt-5 items-center">
                <Link
                  to="/blog"
                  className="w-[7rem] bg-[#DA281C] rounded-lg text-sm  py-3 text-center text-white  transition duration-200 hover:bg-[#757E7E]"
                >
                  Read more
                </Link>
              </div>
            </div>
          </div>

          <div>
            <img
              className="object-cover object-center w-full h-64 rounded-lg lg:h-80"
              src="../Rectangle.png"
              alt=""
            />

            <div className="mt-8">
              <h1 className="mt-4 text-xl font-semibold text-gray-800">
                The Art of Storytelling: How to Use Narrative to Connect with
                Your Audience and Drive Engagement
              </h1>
              <div className="flex items-center justify-between mt-4">
                <div className="flex items-center gap-x-2">
                  <img
                    className="object-cover object-center w-5 h-5 md:w-9 md:h-9 rounded-full "
                    src="../Rectangle.png"
                    alt=""
                  />
                  <h1 className="text-xs sm:text-sm font-semibold text-gray-800">
                    Willion kalu
                  </h1>{" "}
                  -
                  <p className="text-[10px] sm:text-xs text-gray-500 ">
                    February 1, 2022
                  </p>
                </div>
                <p className="text-[8px] sm:text-xs text-gray-500 flex items-center gap-x-1">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_2390_316"
                      style={{ "mask-type": "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="21"
                      height="21"
                    >
                      <rect
                        x="0.00488281"
                        y="0.84082"
                        width="20"
                        height="20"
                        fill="#D9D9D9"
                      />
                    </mask>
                    <g mask="url(#mask0_2390_316)">
                      <path
                        d="M10.0052 19.174C8.85243 19.174 7.7691 18.9552 6.75521 18.5177C5.74132 18.0802 4.85938 17.4865 4.10938 16.7365C3.35937 15.9865 2.76562 15.1045 2.32812 14.0907C1.89062 13.0768 1.67188 11.9934 1.67188 10.8407C1.67188 9.68788 1.89062 8.60455 2.32812 7.59066C2.76562 6.57677 3.35937 5.69482 4.10938 4.94482C4.85938 4.19482 5.74132 3.60107 6.75521 3.16357C7.7691 2.72607 8.85243 2.50732 10.0052 2.50732C11.158 2.50732 12.2413 2.72607 13.2552 3.16357C14.2691 3.60107 15.151 4.19482 15.901 4.94482C16.651 5.69482 17.2448 6.57677 17.6823 7.59066C18.1198 8.60455 18.3385 9.68788 18.3385 10.8407C18.3385 11.2157 18.3177 11.5837 18.276 11.9448C18.2344 12.3059 18.1649 12.6601 18.0677 13.0073C17.8733 12.7851 17.6476 12.5976 17.3906 12.4448C17.1337 12.292 16.8524 12.1879 16.5469 12.1323C16.5885 11.924 16.6198 11.7122 16.6406 11.4969C16.6615 11.2816 16.6719 11.0629 16.6719 10.8407C16.6719 8.97955 16.026 7.40316 14.7344 6.11149C13.4427 4.81982 11.8663 4.17399 10.0052 4.17399C8.1441 4.17399 6.56771 4.81982 5.27604 6.11149C3.98438 7.40316 3.33854 8.97955 3.33854 10.8407C3.33854 12.7018 3.98438 14.2782 5.27604 15.5698C6.56771 16.8615 8.1441 17.5073 10.0052 17.5073C10.7135 17.5073 11.3906 17.4032 12.0365 17.1948C12.6823 16.9865 13.276 16.6948 13.8177 16.3198C13.9844 16.5559 14.1892 16.7643 14.4323 16.9448C14.6753 17.1254 14.9358 17.2643 15.2135 17.3615C14.5052 17.9309 13.7101 18.3754 12.8281 18.6948C11.9462 19.0143 11.0052 19.174 10.0052 19.174ZM16.0469 15.8407C15.7552 15.8407 15.5087 15.74 15.3073 15.5386C15.1059 15.3372 15.0052 15.0907 15.0052 14.799C15.0052 14.5073 15.1059 14.2608 15.3073 14.0594C15.5087 13.858 15.7552 13.7573 16.0469 13.7573C16.3385 13.7573 16.5851 13.858 16.7865 14.0594C16.9878 14.2608 17.0885 14.5073 17.0885 14.799C17.0885 15.0907 16.9878 15.3372 16.7865 15.5386C16.5851 15.74 16.3385 15.8407 16.0469 15.8407ZM12.7552 14.7573L9.17188 11.174V6.67399H10.8385V10.5073L13.9219 13.5907L12.7552 14.7573Z"
                        fill="#576B74"
                      />
                    </g>
                  </svg>
                  10 mins read
                </p>
              </div>
              <p className="mt-2 text-gray-500 ">
                Aenean eleifend ante maecenas pulvinar montes lorem et pede dis
                dolor pretium donec dictum. Vici consequat justo enim. Venenatis
                eget adipiscing luctus lorem.
              </p>
              <div className=" flex gap-x-4 mt-5 items-center">
                <Link
                  to="/blog"
                  className="w-[7rem] bg-[#DA281C] rounded-lg text-sm  py-3 text-center text-white  transition duration-200 hover:bg-[#757E7E]"
                >
                  Read more
                </Link>
              </div>
            </div>
          </div>
          <div>
            <img
              className="object-cover object-center w-full h-64 rounded-lg lg:h-80"
              src="../Rectangle.png"
              alt=""
            />

            <div className="mt-8">
              <h1 className="mt-4 text-xl font-semibold text-gray-800">
                The Art of Storytelling: How to Use Narrative to Connect with
                Your Audience and Drive Engagement
              </h1>
              <div className="flex items-center justify-between mt-4">
                <div className="flex items-center gap-x-2">
                  <img
                    className="object-cover object-center w-5 h-5 md:w-9 md:h-9 rounded-full "
                    src="../Rectangle.png"
                    alt=""
                  />
                  <h1 className="text-xs sm:text-sm font-semibold text-gray-800">
                    Willion kalu
                  </h1>{" "}
                  -
                  <p className="text-[10px] sm:text-xs text-gray-500 ">
                    February 1, 2022
                  </p>
                </div>
                <p className="text-[8px] sm:text-xs text-gray-500 flex items-center gap-x-1">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_2390_316"
                      style={{ "mask-type": "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="21"
                      height="21"
                    >
                      <rect
                        x="0.00488281"
                        y="0.84082"
                        width="20"
                        height="20"
                        fill="#D9D9D9"
                      />
                    </mask>
                    <g mask="url(#mask0_2390_316)">
                      <path
                        d="M10.0052 19.174C8.85243 19.174 7.7691 18.9552 6.75521 18.5177C5.74132 18.0802 4.85938 17.4865 4.10938 16.7365C3.35937 15.9865 2.76562 15.1045 2.32812 14.0907C1.89062 13.0768 1.67188 11.9934 1.67188 10.8407C1.67188 9.68788 1.89062 8.60455 2.32812 7.59066C2.76562 6.57677 3.35937 5.69482 4.10938 4.94482C4.85938 4.19482 5.74132 3.60107 6.75521 3.16357C7.7691 2.72607 8.85243 2.50732 10.0052 2.50732C11.158 2.50732 12.2413 2.72607 13.2552 3.16357C14.2691 3.60107 15.151 4.19482 15.901 4.94482C16.651 5.69482 17.2448 6.57677 17.6823 7.59066C18.1198 8.60455 18.3385 9.68788 18.3385 10.8407C18.3385 11.2157 18.3177 11.5837 18.276 11.9448C18.2344 12.3059 18.1649 12.6601 18.0677 13.0073C17.8733 12.7851 17.6476 12.5976 17.3906 12.4448C17.1337 12.292 16.8524 12.1879 16.5469 12.1323C16.5885 11.924 16.6198 11.7122 16.6406 11.4969C16.6615 11.2816 16.6719 11.0629 16.6719 10.8407C16.6719 8.97955 16.026 7.40316 14.7344 6.11149C13.4427 4.81982 11.8663 4.17399 10.0052 4.17399C8.1441 4.17399 6.56771 4.81982 5.27604 6.11149C3.98438 7.40316 3.33854 8.97955 3.33854 10.8407C3.33854 12.7018 3.98438 14.2782 5.27604 15.5698C6.56771 16.8615 8.1441 17.5073 10.0052 17.5073C10.7135 17.5073 11.3906 17.4032 12.0365 17.1948C12.6823 16.9865 13.276 16.6948 13.8177 16.3198C13.9844 16.5559 14.1892 16.7643 14.4323 16.9448C14.6753 17.1254 14.9358 17.2643 15.2135 17.3615C14.5052 17.9309 13.7101 18.3754 12.8281 18.6948C11.9462 19.0143 11.0052 19.174 10.0052 19.174ZM16.0469 15.8407C15.7552 15.8407 15.5087 15.74 15.3073 15.5386C15.1059 15.3372 15.0052 15.0907 15.0052 14.799C15.0052 14.5073 15.1059 14.2608 15.3073 14.0594C15.5087 13.858 15.7552 13.7573 16.0469 13.7573C16.3385 13.7573 16.5851 13.858 16.7865 14.0594C16.9878 14.2608 17.0885 14.5073 17.0885 14.799C17.0885 15.0907 16.9878 15.3372 16.7865 15.5386C16.5851 15.74 16.3385 15.8407 16.0469 15.8407ZM12.7552 14.7573L9.17188 11.174V6.67399H10.8385V10.5073L13.9219 13.5907L12.7552 14.7573Z"
                        fill="#576B74"
                      />
                    </g>
                  </svg>
                  10 mins read
                </p>
              </div>
              <p className="mt-2 text-gray-500 ">
                Aenean eleifend ante maecenas pulvinar montes lorem et pede dis
                dolor pretium donec dictum. Vici consequat justo enim. Venenatis
                eget adipiscing luctus lorem.
              </p>
              <div className=" flex gap-x-4 mt-5 items-center">
                <Link
                  to="/blog"
                  className="w-[7rem] bg-[#DA281C] rounded-lg text-sm  py-3 text-center text-white  transition duration-200 hover:bg-[#757E7E]"
                >
                  Read more
                </Link>
              </div>
            </div>
          </div>
          <div>
            <img
              className="object-cover object-center w-full h-64 rounded-lg lg:h-80"
              src="../Rectangle.png"
              alt=""
            />

            <div className="mt-8">
              <h1 className="mt-4 text-xl font-semibold text-gray-800">
                The Art of Storytelling: How to Use Narrative to Connect with
                Your Audience and Drive Engagement
              </h1>
              <div className="flex items-center justify-between mt-4">
                <div className="flex items-center gap-x-2">
                  <img
                    className="object-cover object-center w-5 h-5 md:w-9 md:h-9 rounded-full "
                    src="../Rectangle.png"
                    alt=""
                  />
                  <h1 className="text-xs sm:text-sm font-semibold text-gray-800">
                    Willion kalu
                  </h1>{" "}
                  -
                  <p className="text-[10px] sm:text-xs text-gray-500 ">
                    February 1, 2022
                  </p>
                </div>
                <p className="text-[8px] sm:text-xs text-gray-500 flex items-center gap-x-1">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_2390_316"
                      style={{ "mask-type": "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="21"
                      height="21"
                    >
                      <rect
                        x="0.00488281"
                        y="0.84082"
                        width="20"
                        height="20"
                        fill="#D9D9D9"
                      />
                    </mask>
                    <g mask="url(#mask0_2390_316)">
                      <path
                        d="M10.0052 19.174C8.85243 19.174 7.7691 18.9552 6.75521 18.5177C5.74132 18.0802 4.85938 17.4865 4.10938 16.7365C3.35937 15.9865 2.76562 15.1045 2.32812 14.0907C1.89062 13.0768 1.67188 11.9934 1.67188 10.8407C1.67188 9.68788 1.89062 8.60455 2.32812 7.59066C2.76562 6.57677 3.35937 5.69482 4.10938 4.94482C4.85938 4.19482 5.74132 3.60107 6.75521 3.16357C7.7691 2.72607 8.85243 2.50732 10.0052 2.50732C11.158 2.50732 12.2413 2.72607 13.2552 3.16357C14.2691 3.60107 15.151 4.19482 15.901 4.94482C16.651 5.69482 17.2448 6.57677 17.6823 7.59066C18.1198 8.60455 18.3385 9.68788 18.3385 10.8407C18.3385 11.2157 18.3177 11.5837 18.276 11.9448C18.2344 12.3059 18.1649 12.6601 18.0677 13.0073C17.8733 12.7851 17.6476 12.5976 17.3906 12.4448C17.1337 12.292 16.8524 12.1879 16.5469 12.1323C16.5885 11.924 16.6198 11.7122 16.6406 11.4969C16.6615 11.2816 16.6719 11.0629 16.6719 10.8407C16.6719 8.97955 16.026 7.40316 14.7344 6.11149C13.4427 4.81982 11.8663 4.17399 10.0052 4.17399C8.1441 4.17399 6.56771 4.81982 5.27604 6.11149C3.98438 7.40316 3.33854 8.97955 3.33854 10.8407C3.33854 12.7018 3.98438 14.2782 5.27604 15.5698C6.56771 16.8615 8.1441 17.5073 10.0052 17.5073C10.7135 17.5073 11.3906 17.4032 12.0365 17.1948C12.6823 16.9865 13.276 16.6948 13.8177 16.3198C13.9844 16.5559 14.1892 16.7643 14.4323 16.9448C14.6753 17.1254 14.9358 17.2643 15.2135 17.3615C14.5052 17.9309 13.7101 18.3754 12.8281 18.6948C11.9462 19.0143 11.0052 19.174 10.0052 19.174ZM16.0469 15.8407C15.7552 15.8407 15.5087 15.74 15.3073 15.5386C15.1059 15.3372 15.0052 15.0907 15.0052 14.799C15.0052 14.5073 15.1059 14.2608 15.3073 14.0594C15.5087 13.858 15.7552 13.7573 16.0469 13.7573C16.3385 13.7573 16.5851 13.858 16.7865 14.0594C16.9878 14.2608 17.0885 14.5073 17.0885 14.799C17.0885 15.0907 16.9878 15.3372 16.7865 15.5386C16.5851 15.74 16.3385 15.8407 16.0469 15.8407ZM12.7552 14.7573L9.17188 11.174V6.67399H10.8385V10.5073L13.9219 13.5907L12.7552 14.7573Z"
                        fill="#576B74"
                      />
                    </g>
                  </svg>
                  10 mins read
                </p>
              </div>
              <p className="mt-2 text-gray-500 ">
                Aenean eleifend ante maecenas pulvinar montes lorem et pede dis
                dolor pretium donec dictum. Vici consequat justo enim. Venenatis
                eget adipiscing luctus lorem.
              </p>
              <div className=" flex gap-x-4 mt-5 items-center">
                <Link
                  to="/blog"
                  className="w-[7rem] bg-[#DA281C] rounded-lg text-sm  py-3 text-center text-white  transition duration-200 hover:bg-[#757E7E]"
                >
                  Read more
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog;
